export default __webpack_public_path__ + "32b4aa502dab3c85049cb8da16db2c8b.png";